<template>
  <CreateOperationModal/>
  <div class="col-lg-12 radius-7">
    <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing radius-7">
      <div
        class="card-head box-shadow bg-white d-md-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25 radius-7"
      >
        <h5>Operações cadastradas</h5>
        <div class="d-sm-flex align-items-center">
          <a
            class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
            href="#"
            data-bs-toggle="modal"
            data-bs-target="#CreateOperationModal"
          >
          <i class="flaticon-plus position-relative me-5 fs-12"></i>
          Criar nova operação
          </a>
        </div>
      </div>
      
      <div class="card-body p-15 p-sm-20 p-md-25">
        <div class="table-responsive">
          <table class="table text-nowrap align-middle mb-0">
            <thead>
              <tr>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
                >
                  Nome
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                  Token
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                  STATUS
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 justify-content-end pe-0 d-flex"
                >
                  Editar
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(operation, key) in getOperations" :key="key">
                <th
                  class="shadow-none lh-1 fw-medium text-black-emphasis title ps-0"
                >
                  <div class="d-flex align-items-center">
                    <div
                      class="d-flex align-items-center ms-5 fs-md-15 fs-lg-16"
                    >
                      {{ operation.name }}
                    </div>
                  </div>
                </th>
                <td class="shadow-none lh-1 fw-medium text-black-emphasis title ps-0">
                  <div class="d-flex align-items-center ms-5 fs-md-15 fs-lg-16">
                    {{ operation.token }}
                  </div>
                </td>
                <td class="shadow-none lh-1 fw-medium">
                  <span class="badge" :class="{'text-outline-success': operation.active, 'badge text-outline-danger': !operation.active}">{{ operation.active == 1 ? "Ativo" : "Inativo" }}</span>
                </td>
                <td class="shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0 d-flex justify-content-end">
                  <router-link :to="'/operation/'+operation.id" class="position-relative transition border-0 fw-medium text-white p-10 rounded-1 bg-info d-flex ms-5 mt-5 me-5 mb-5 text-decoration-none ms-0 fit-content">
                    <i class="flaticon-edit position-relative fs-16 d-flex lh-1"></i>
                  </router-link>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      <!-- PÁGINAÇÃO AQUI... -->

      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CreateOperationModal from './CreateOperationModal.vue';
export default {
  name: "ListOperations",
    computed:{
    ...mapGetters([
        'getOperations'
    ])
  },
  components: {
    CreateOperationModal
  },
};
</script>